var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.button)?_c('div',{staticClass:"action-next"},[_c('button',{staticClass:"button is-success is-fullwidth is-large",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"is-small is-size-6 has-text-left has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.button)+" ")]),_c('span',{staticClass:"icon ml-2 is-size-6"},[_c('span',{class:['fa', {
        'fas fa-chevron-right': !_vm.loading,
        'fa-spin fa-spinner': _vm.loading,
      }]})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }